// extracted by mini-css-extract-plugin
export default {"button":"Button-module--button--TJE5P"};